import { Information } from "reduxState/informations/informationsSlice";

export const INFORMATION: { [key: string]: Information } = {
  UNAUTHORIZED: {
    id: "unauthorized",
    title: "accessToastTitle",
    description: "accessToastDescription",
    type: "info",
    order: 1,
  },
  UNPAID_INVOICE: {
    id: "unpaidInvoice",
    title: "actionRequired",
    description: "unpaidInvoiceToastDescription",
    type: "warn",
  },
};
